import styled from 'styled-components'

export const JobDetailStyle = styled.div`
  .left-job-detail {
    width: calc(100% - 372px);
    margin-right: 20px;
    display: inline-block;
    border-radius: 8px;
    border: solid 1px #ffe8d0;

    .left-job-detail-top {
      position: relative;
      height: 226px;
      border-top-left-radius: 8px;
      border-top-right-radius: 8px;
      border-bottom: solid 2px #dcdcdc;

      img {
        width: 100%;
      }

      .left-job-detail-top-text {
        position: absolute;
        left: 22px;
        bottom: 24px;

        p {
          color: #555555;
          margin: 0;

          &:nth-child(2) {
            font-size: 24px;
            font-weight: bold;
            margin-top: 12px;
          }
        }
      }
    }

    .left-job-detail-bottom {
      padding: 0 20px 20px 20px;
      background: transparent;

      p {
        margin: 0;
        margin-top: 15px;

        &.description-title {
          color: #ff7e00;
          font-size: 18px;
        }

        &.description-text {
          color: #888888;
          font-size: 18px;
          line-height: 1.61;
        }
      }
    }
  }

  .right-job-detail {
    width: 352px;
    display: inline-block;
    border: solid 1px #ffe8d0;
    border-radius: 8px;
    padding: 32px;
    position: relative;
    height: 100%;

    .captcha-wrapper {
      padding-top: 20px;
    }
    .error-handling {
      margin-top: -20px;
      font-size: 12px;
      color: red;
      font-weight: normal;
      margin-bottom: 12px;
    }

    p {
      font-size: 24px;
      font-weight: 600;
      color: #ff7400;
      margin: 0 0 30px 0;
    }

    label {
      display: block;
      font-size: 14px;
      font-weight: 600;
      color: #555555;
      margin-bottom: 10px;
    }

    input {
      margin-bottom: 20px;
      border: solid 1px #dddddd;
      background-color: #fbfbfb;
      width: 100%;
      line-height: 1;
      padding: 10px 12px;
    }

    .button-kirim {
      width: 100%;
      margin-top: 30px;
      border-radius: 22.5px;
      background-image: linear-gradient(to left, #ff9700, #ff7400);
      color: #ffffff;
      text-align: center;
      line-height: 1;
      padding: 15px 0;
      border: none;
      cursor: pointer;
      transition: ease-in-out 0.3s;

      &:hover {
        transform: scale(0.95);
      }
    }

    .upload-wrapper {
      position: relative;

      p {
        &:nth-child(1) {
          font-size: 14px;
          font-weight: 600;
          color: #555555;
          margin: 0;
        }

        &:nth-child(2) {
          font-size: 12px;
          font-weight: normal;
          color: #888888;
          margin: 10px 0;
        }
      }

      .upload-file-wrapper {
        padding: 10px;
        border-radius: 8px;
        border: solid 1px #dcdcdc;

        img {
          width: 93px;
          height: 62px;
          display: inline-block;
          vertical-align: top;
        }

        div {
          width: calc(100% - 108px);
          margin-left: 15px;
          display: inline-block;
        }

        .file-text {
          font-size: 12px;
          font-weight: normal;
          color: #555555;
          overflow: hidden;
          margin-bottom: 7px;
        }

        button {
          width: 100px;
          background: none;
          border: solid 1px #4866c9;
          color: #4866c9;
          text-align: center;
          line-height: 1;
          padding: 12px 0;
          font-weight: bold;
          border-radius: 8px;
          margin-top: 10px;
          cursor: pointer;
          transition: ease-in-out 0.3s;

          &:hover {
            transform: scale(0.95);
          }
        }
        .input-image {
          display: none;
        }
      }
    }
  }

  @media screen and (min-width: 300px) and (max-width: 1023px) {
    .left-job-detail-top {
      height: 115px !important;

      img {
        height: 115px;
      }
    }

    .breadcrumb {
      display: none;
    }

    .main-job-list-wrapper {
      padding-top: 0 !important;

      .container {
        padding: 0;
      }

      .left-job-detail {
        margin-right: 0;
        width: 100%;
        margin-bottom: 20px;
        border: none;
        margin-top: 31px;
      }

      .right-job-detail {
        width: calc(100% - 30px);
        position: relative;
        left: 15px;

        .error-handling {
          margin-top: -20px;
          font-size: 12px;
          color: red;
          font-weight: normal;
          margin-bottom: 12px;
        }
      }

      .button-kirim {
        position: relative;
        left: unset;
        bottom: unset;
        width: 100%;
        margin-top: 40px;
      }
    }
  }

  h1 {
    color: #3a3a3a;
  }
`
